export default __webpack_public_path__ + "static/media/description-kana.b0e45049.png";